/** A GPS integration is a record with its own tabs, `/integrations/gps/:id/<tab>` (`recordTabRoutes`); installing one is a sheet over the Integrations page. */
export const GPS_INTEGRATION_TABS = ['devices', 'settings'] as const;
export type GpsIntegrationTab = (typeof GPS_INTEGRATION_TABS)[number];

export const GPS_INTEGRATION_TAB_LABELS: Record<GpsIntegrationTab, string> = { devices: 'Devices', settings: 'Settings' };

export function installGpsIntegrationPath(adapterKey: string): string {
  return `/integrations/gps/new?adapter=${encodeURIComponent(adapterKey)}`;
}

export function gpsIntegrationPath(id: string): string {
  return `/integrations/gps/${id}`;
}

export function gpsIntegrationTabPath(id: string, tab: GpsIntegrationTab): string {
  return `${gpsIntegrationPath(id)}/${tab}`;
}

/** The map sheet over the Devices tab, with the device already chosen when it came from the unmapped list. */
export function mapDevicePath(id: string, deviceId?: string): string {
  const path = `${gpsIntegrationTabPath(id, 'devices')}/map`;
  return deviceId ? `${path}?device=${encodeURIComponent(deviceId)}` : path;
}
